module.exports = __webpack_public_path__ + "img/github-fill.2dcd6a9d.svg";